import { Base } from '../base';

export class Incomings extends Base {
    ZoneID: number;
    ZoneName: string;
    PaymentMethodTypeID: number;
    Total: number;
    TotalAmount: number;
    NetTotalAmount: number;
    CurrencyID?: number;
}
